module.exports = __webpack_public_path__ + "fonts/webfont.6378e778.ttf";